import { useContext, useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import CustomButton from "../../Components/Base/CustomButton";
import InputTextBox from "../../Components/Base/InputTextBox";
import SelectOption from "../../Components/Base/SelectOption";
import InValidAccess from "../../Components/InValidAccess";
import Loader from "../../Components/Loder";
import PageBar from "../../Components/ToolBar/PageBar";
import ToolBar from "../../Components/ToolBar/ToolBar";
import AppContext from "../../Context/AppContext";
import { RestReportBean } from "../../Ds/client_ds";
import {
  PageListBean,
  RestSKUBatchInventoryTrackListRequest,
  SKUBatchInventoryTrackSearchCriteria,
  RestFabricStyleListRequest,
  FabricStyleSearchCriteria,
} from "../../Ds/ds";
import service from "../../Services/Service";
import { TOAST_ERROR, TOAST_SUCESS } from "../../Utils/appConstants";
import { isEmpty, isEmptyArray, isEmptyString } from "../../Utils/util";

export default function TestInquiry() {
  const { token, setisSessionExpeired, session } = useContext(AppContext);

  const [code, setCode] = useState("");
  const [dataList, setDataList] = useState([]);
  const [disable, setDisable] = useState(false);
  const title = "Test";

  const inputRef = useRef(null);
  const buttonRef = useRef(null);

  const setFocus = () => {
    if (inputRef.current != null) inputRef.current.focus();
  };

  useEffect(() => {
    setFocus();
  }, []);

  const notify = (type, msg, theme) => {
    if (type === 1)
      toast.info(msg, {
        theme: theme,
      });
    else if (type === 2)
      toast.error(msg, {
        theme: theme,
      });
    else if (type === 3)
      toast.success(msg, {
        theme: theme,
      });
    else if (type === 4)
      toast.warn(msg, {
        theme: theme,
      });
    else toast(msg);
  };

  const errorCallBack = (error) => {
    notify(TOAST_ERROR, error);
  };

  const enterKeyHandler = (e) => {};

  const buttonHandler = (e) => {};

  const onChange = (e) => {
    setCode(e.target.value.toUpperCase());
  };

  const ResetHandler = () => {
    setDataList([]);
    setDisable(false);
    setCode("");
    setFocus();
  };

  const options = [
    "Afghanistan",
    "Albania",
    "Algeria",
    "Andorra",
    "Angola",
    "Anguilla",
    "Antigua & Barbuda",
    "Argentina",
    "Armenia",
    "Aruba",
    "Australia",
  ];
  const onClose = () => {
    setIsAccessible(false);
  };
  const [isAccessible, setIsAccessible] = useState(true);
  return (
    <>
      <div>hi</div>
      <InValidAccess isShow={isAccessible} clickHandler={onClose} />
    </>
  );
}
